import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className, as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const MaskedLines = ({ lines, as = "h1", className, delay = 0.15, lineClassName, testid }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testid}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={lineClassName ? `block ${lineClassName(i)}` : "block"}
            initial={{ y: "105%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
